<template>
  <div ref="select" :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>

    <div v-bind="{ ...$attrs, class: null }" class="form-select relative" :class="{ error: error }">
      <input v-model="search" type="text" :placeholder="placeholder" @focusin="isOpen = true" />

      <div v-show="isOpen && data.length" class="absolute z-20 right-0 left-0 h-[200px] overflow-y-auto bg-white shadow-md rounded-sm p-2">
        <template v-for="item in data" :key="item">
          <p class="py-1 cursor-pointer" @click.stop="handleClickOpetion( item[ optionLabel ], item[ textLabel ] )">{{ item[ textLabel ] }}</p>
        </template>
      </div>
    </div>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>


import { v4 as uuid } from 'uuid'

export default {

  props: {
    id: {
      type: String,
      default() {
        return `select-input-${uuid()}`
      },
    },
    error: {
      type: String,
    },
    label: String,

    data: {
      type: Array,
      default: [],
    },

    optionLabel: String,
        
    textLabel: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      default: '',
    },

    modelValue: {
      type: String,
    },
  },

  emits: [ 'update:modelValue', 'search' ],


  data() {
    return {
      isOpen: false,
      selected: this.handleGetSelected(this.$props.modelValue),
      search: this.$props.modelValue,
    }
  },

  watch: {
    search() {
      this.$emit( 'search', this.search )
    },
  },

  mounted() {
    document.addEventListener( 'click', this.handleClickDocument )
  },

  unmounted() {
    document.removeEventListener( 'click', this.handleClickDocument )
  },

  methods: {
    handleGetSelected(value) {
      if (typeof(value) == 'object')
        return this.$props.modelValue.label
        
      return this.$props.modelValue
    },

    handleClickDocument( $event ) {
      if ( !this.$refs.select.contains( $event.target ) ) {
        this.isOpen = false
        this.search = this.selected
      }
    },

    handleClickOpetion( option, text ) {
      this.selected = text
      this.search = text
      this.isOpen = false
      this.$emit( 'update:modelValue', {
        value: option,
        label: text,
      })
    },
  },
}

</script>
